const copyBtns = document.querySelectorAll(".js-copy-btn");

if (typeof copyBtns != "undefined" && copyBtns != null) {

    const copyTextarea = document.querySelector(".js-copytextarea");
    let successful, btnMsg;

    copyBtns.forEach((copyBtn) => {

        copyBtn.addEventListener("click", function (event) {
        
           // copyTextarea.focus();
            copyTextarea.select();

            try {
                successful = document.execCommand("copy");
                btnMsg = successful ? "Text Copied!" : "Error";
            } catch (err) {
                console.warn(err);
            }

            copyBtn.textContent = btnMsg;
        });

    });

}
